module.exports = __webpack_public_path__ + "img/mir.94d166ad.svg";